import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../useAxios"
import { useTranslation } from "react-i18next";
import { Language } from "@types";

export const useGetLanguages = () => {

    const axios = useAxios();
    const { t } = useTranslation();

    const fetchLanguages = async () => {
        try {
            const { data } = await axios.get<Language[]>("/api/language");
            return data;
        } catch (error) {
            throw new Error(t("messages.error.getLanguages"));
        }
    }

    return useQuery({queryKey: ["languages"], queryFn: fetchLanguages, staleTime: Infinity})
}